(() => {
  function init(root = document) {
    root.querySelectorAll('.reference-purchase[data-product-form] .product-option--select').forEach(group => {
      if (group.closest('[data-product-section]')?.querySelector('.oe-stock')) return;
      const select = group.querySelector('select[data-product-option]');
      if (!select || !/size/i.test(select.getAttribute('aria-label') || '') || group.querySelector('.oe-sizes')) return;
      const choices = document.createElement('div');
      choices.className = 'oe-sizes';
      const sync = () => [...choices.children].forEach(button => {
        const selected = button.dataset.value === select.value;
        button.classList.toggle('on', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      [...select.options].forEach(option => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = option.textContent;
        button.dataset.value = option.value;
        button.disabled = option.disabled;
        button.addEventListener('click', () => {
          select.value = option.value;
          select.dispatchEvent(new Event('change', {bubbles: true}));
        });
        choices.appendChild(button);
      });
      select.after(choices);
      select.addEventListener('change', sync);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
